import { useMemo } from 'react'

import { LoadPastIterationsButton } from '@/components/LoadPastIterationsButton.tsx'
import { Divider } from '@/components/dividers/Divider.tsx'
import { IterationDividerLabel } from '@/components/dividers/IterationDividerLabel.tsx'
import { useGroupDoneStories } from '@/hooks/useGroupDoneStories.tsx'
import { useQueryCurrentIteration } from '@/requests/queries/useQueryProject.ts'

type Props = {
  filter?: (stories: Story[]) => Story[]
}

export const DonePanel = ({ filter }: Props) => {
  const { currentIteration } = useQueryCurrentIteration()
  const groupedStories = useGroupDoneStories()

  const renderList = useMemo(() => {
    if (filter) {
      return groupedStories.map((iterationWithStories) => ({
        ...iterationWithStories,
        stories: filter(iterationWithStories.stories),
      }))
    }
    return groupedStories
  }, [groupedStories, filter])

  return (
    <div className="flex-1 flex flex-col overflow-auto gap-2 bg-surface-backgroundElevated rounded-xl p-2 pr-0.5 min-w-[520px]">
      <div className="font-EN-KR-heading3-bold h-8 flex items-center justify-between text-contents-primary">
        <h2>Done</h2>
        <LoadPastIterationsButton />
      </div>
      <div className="flex-1 overflow-scroll tracker-scrollbar">
        <ul className="overflow-hidden">
          {renderList.length === 0 && (
            <li className="flex justify-center items-center h-[216px] bg-surface-backgroundElevated">
              <p className="text-center font-EN-KR-body1-regular text-tb-grey-700">
                The implemented stories are displayed here.
              </p>
            </li>
          )}
          <ul className="flex flex-col gap-1">
            {renderList.map((element) => (
              <Divider
                key={element.number}
                uniqueKey={element.number.toString()}
                stories={element.stories}
                isClosedByDefault={element.number < currentIteration?.number - 4 || element.stories.length === 0}
              >
                <IterationDividerLabel key={element.number} {...element} type="done" />
              </Divider>
            ))}
          </ul>
        </ul>
      </div>
    </div>
  )
}
